module.exports = __webpack_public_path__ + "img/join_3.a9137aa3.png";